import { BasicAttributes } from './sections/BasicAttributes'
import { BulkManagement } from './sections/BulkManagement'

export const WorkspaceForm = (): React.JSX.Element => {
  return (
    <>
      <BasicAttributes />
      <BulkManagement />
    </>
  )
}
